import { default as axios } from 'axios'
import evaluationCampaign from '@/services/evaluationCampaign/evaluationCampaignHttp.service'
import timesheetDailyDetails from '@/services/timesheetDailyDetails/timesheetDailyDetailsHttp.service'
import companyContact from '@/services/companyContact/companyContactHttp.service'
import activity from '@/services/activity/activityHttp.service'
import salesWorkflow from '@/services/salesWorkflow/salesWorkflowHttp.service'
import salesFunnelView from '@/services/salesFunnelView/salesFunnelViewHttp.service'
import crmCustomField from '@/services/crmCustomField/crmCustomFieldHttp.service'
import salesIcpConfig from '@/services/salesIcpConfig/salesIcpConfigHttp.service'
import salesAi from '@/services/salesAi/salesAiHttp.service'
import salesDueDiligence from '@/services/salesDueDiligence/salesDueDiligenceHttp.service'
import assistant from '@/services/assistant/assistantHttp.service'
import proposal from '@/services/proposal/proposalHttp.service'
import user from '@/services/user/userHttp.service'
import resource from '@/services/resource/resourceHttp.service'
import excel from '@/services/excel/excelHttp.service'
import job from '@/services/job/jobHttp.service'
import team from '@/services/team/teamHttp.service'
import office from '@/services/office/officeHttp.service'
import training from '@/services/training/trainingHttp.service'
import elearningCourse from '@/services/elearningCourse/elearningCourseHttp.service'
import learningPath from '@/services/learningPath/learningPathHttp.service'
import elearningAssignment from '@/services/elearningAssignment/elearningAssignmentHttp.service'
import elearningPathAssignment from '@/services/elearningPathAssignment/elearningPathAssignmentHttp.service'
import academy from '@/services/academy/academyHttp.service'
import academyManagement from '@/services/academy/academyManagementHttp.service'
import trainingLocation from '@/services/trainingLocation/trainingLocationHttp.service'
import trainingSession from '@/services/trainingSession/trainingSessionHttp.service'
import trainingPlanDraft from '@/services/trainingPlanDraft/trainingPlanDraftHttp.service'
import trainingCategory from '@/services/trainingCategory/trainingCategoryHttp.service'
import trainingItemCategory from '@/services/trainingItemCategory/trainingItemCategoryHttp.service'
import trainingItem from '@/services/trainingItem/trainingItemHttp.service'
import trainingCostCategory from '@/services/trainingCostCategory/trainingCostCategoryHttp.service'
import trainingBudget from '@/services/trainingBudget/trainingBudgetHttp.service'
import trainingTrainer from '@/services/trainingTrainer/trainingTrainerHttp.service'
import trainer from '@/services/trainer/traininerHttp.service'
import jobOffer from '@/services/jobOffer/jobOfferHttp.service'
import firm from '@/services/firm/firmHttp.service'
import document from '@/services/document/documentHttp.service'
import project from '@/services/project/projectHttp.service'
import skill from '@/services/skill/skillHttp.service'
import skillCategory from '@/services/skillCategory/skillCategoryHttp.service'
import projectCategory from '@/services/projectCategory/projectCategoryHttp.service'
import search from '@/services/search/searchHttp.service'
import recruitment from '@/services/recruitment/recruitmentHttp.service'
import candidateSpace from '@/services/candidateSpace/candidateSpaceHttp.service'
import room from '@/services/room/roomHttp.service'
import company from '@/services/company/companyHttp.service'
import comment from '@/services/comment/commentHttp.service'
import formular from '@/services/formular/formularHttp.service'
import survey from '@/services/survey/surveyHttp.service'
import projectStatus from '@/services/projectStatus/projectStatusHttp.service'
import leave from '@/services/leave/leaveHttp.service'
import sector from '@/services/sector/sectorHttp.service'
import holiday from '@/services/holiday/holidayHttp.service'
import dashboard from '@/services/dashboard/dashboardHttp.service'
import usergroup from '@/services/usergroup/usergroupHttp.service'
import timesheet from '@/services/timesheet/timesheetHttp.service'
import contractTypeHttpService from '@/services/contractType/contractTypeHttp.service'
import contractSuperTypeHttpService from '@/services/contractSuperType/contractSuperTypeHttp.service'
import timesheetActivity from '@/services/timesheetActivity/timesheetActivityHttp.service'
import invoicingInformation from '@/services/invoicingInformation/invoicingInformationHttp.service'
import employeeWage from '@/services/employeeWage/employeeWageHttp.service'
import publicHoliday from '@/services/publicHoliday/publicHolidayHttp.service'
import timeZone from '@/services/timeZone/timeZoneHttp.service'
import leaveType from '@/services/leaveType/leaveTypeHttp.service'
import evaluation from '@/services/evaluation/evaluationHttp.service'
import evaluationAverage from '@/services/evaluationAverage/evaluationAverageHttp.service'
import recruitmentMailTemplate from '@/services/recruitmentMailTemplate/recruitmentMailTemplateHttp.service'
import recruitmentRejectionCategory from '@/services/recruitmentRejectionCategory/recruitmentRejectionCategoryHttp.service'
import recruitmentWithdrawalCategory from '@/services/recruitmentWithdrawalCategory/recruitmentWithdrawalCategoryHttp.service'
import profileHttpService from '@/services/profile/profileHttp.service'
import invoice from '@/services/invoice/invoiceHttp.service'
import evaluationSummary from '@/services/evaluationSummary/evaluationSummaryHttp.service'
import axiosConfig from '@/config/axios.config'
import management from '@/services/management/managementHttp.service'
import invoicingProjects from '@/services/invoicingProjects/invoicingProjectsHttp.service'
import invoicingTerm from '@/services/invoicingTerm/invoicingTermHttp.service'
import bankAccount from '@/services/bankAccount/bankAccountHttp.service'
import expense from '@/services/expense/expenseHttp.service'
import school from '@/services/school/schoolHttp.service'
import schoolCategory from '@/services/schoolCategory/schoolCategoryHttp.service'
import degreeCategory from '@/services/degreeCategory/degreeCategoryHttp.service'
import message from '@/services/message/messageHttp.service'
import RecruitmentWebsite from '@/services/recruitmentWebsite/recruitmentWebsiteHttp.service'
import boardingProcess from '@/services/onboardingProcess/boardingProcessHttp.service'
import jobOfferStatistic from '@/services/jobOfferStatistic/jobOfferStatisticHttp.service'
import userLogAction from '@/services/userLogAction/userLogActionHttp.service'
import howDidYouFindUs from '@/services/howDidYouFindUs/howDidYouFindUsHttp.service'
import employeeOnboarding from '@/services/employeeOnboarding/employeeOnboardingHttp.service'
import meeting from '@/services/meeting/meetingHttp.service'
import country from '@/services/country/countryHttp.service'
import resourceChildren from '@/services/resourceChildren/resourceChildrenHttp.service'
import jobBoardFormTemplate from '@/services/jobBoardFormTemplate/jobBoardFormTemplateHttp.service'
import expenseReport from '@/services/expenseReport/expenseRepportHttp.service'
import jobStatus from '@/services/jobStatus/jobStatusHttp.service'
import departureCategory from '@/services/departureCategory/departureCategoryHttp.service'
import degreeFieldCategory from '@/services/degreeFieldCategory/degreeFieldCategoryHttp.service'
import expenseCategory from '@/services/expenseCategory/expenseCategoryHttp.service'
import customRecruitmentQuestion from '@/services/customRecruitmentQuestion/customRecruitmentQuestionHttp.service'
import signatureDocument from '@/services/signatureDocument/signatureDocumentHttp.service'
import signatureTemplate from '@/services/signatureTemplate/signatureTemplateHttp.service'
import signatureCampaign from '@/services/signatureCampaign/signatureCampaignHttp.service'
import objectItemCategory from '@/services/objectItemCategory/objectItemCategoryHttp.service'
import objectItem from '@/services/objectItem/objectItemHttp.service'
import objective from '@/services/objective/objectiveHttp.service'
import projectCommissionCategory from '@/services/projectCommissionCategory/projectCommissionCategoryHttp.service'
import projectPricingCategory from '@/services/projectPricingCategory/projectPricingCategoryHttp.service'
import employeeVariables from '@/services/employeeVariables/employeeVariablesHttp.service'
import acknowledgmentCandidateReceiptTemplateHttpService from '@/services/acknowledgmentCandidateReceiptTemplate/acknowledgmentCandidateReceiptTemplateHttp.service'
import alertRule from '@/services/alert/alertRuleHttp.service'
import triggeredAlert from '@/services/alert/triggeredAlertHttp.service'
import ticket from '@/services/ticket/ticketHttp.service'
import adminTicket from '@/services/adminTicket/adminTicketHttp.service'
import adminSearch from '@/services/adminSearch/adminSearchHttp.service'
import aiUsage from '@/services/aiUsage/aiUsageHttp.service'
import currency from '../currency/currencyHttp.service'
import recruitmentTag from '@/services/recruitmentTag/recruitmentTagHttp.service'
import jobCategory from '@/services/jobCategory/jobCategoryHttp.service'
import jobPath from '@/services/jobPath/jobPathHttp.service'
import userSession from '@/services/userSession/userSessionHttp.service'
import adminUserSession from '@/services/userSession/adminUserSessionHttp.service'
import signatureStats from '@/services/signatureStats/signatureStatsHttp.service'
import apiUser from '@/services/apiUser/apiUserHttp.service'
import integration from '@/services/integration/integrationHttp.service'
import jobBoard from '@/services/jobBoard/jobBoardHttp.service'
import exportTemplate from '@/services/exportTemplate/exportTemplateHttp.service'
import contentAsset from '@/services/contentAsset/contentAssetHttp.service'
import firmNews from '@/services/firmNews/firmNewsHttp.service'
import meetingExchange from '@/services/meetingExchange/meetingExchangeHttp.service'
import openReplay from '@/services/openReplay/openReplayHttp.service'
import chat from '@/services/chat/chatHttp.service'
import outlook from '@/services/outlook/outlookHttp.service'

const updatedAxios = axiosConfig(axios)

export const objectItemCategoryApi  = objectItemCategory(updatedAxios);
export const objectItemApi  = objectItem(updatedAxios);
export const userApi = user(updatedAxios)
export const excelApi = excel(updatedAxios)
export const resourceApi = resource(updatedAxios)
export const evaluationCampaignApi = evaluationCampaign(updatedAxios)
export const jobApi = job(updatedAxios)
export const alertRuleApi = alertRule(updatedAxios)
export const triggeredAlertApi = triggeredAlert(updatedAxios)
export const jobOfferApi = jobOffer(updatedAxios)
export const expenseCategoryApi = expenseCategory(updatedAxios)
export const companyApi = company(updatedAxios)
export const firmApi = firm(updatedAxios)
export const recruitmentMailTemplateApi = recruitmentMailTemplate(updatedAxios)
export const teamApi = team(updatedAxios)
export const projectApi = project(updatedAxios)
export const officeApi = office(updatedAxios)
export const schoolApi = school(updatedAxios)
export const schoolCategoryApi = schoolCategory(updatedAxios)
export const degreeCategoryApi = degreeCategory(updatedAxios)
export const sectorApi = sector(updatedAxios)
export const documentApi = document(updatedAxios)
export const skillApi = skill(updatedAxios)
export const skillCategoryApi = skillCategory(updatedAxios)
export const dashboardApi = dashboard(updatedAxios)
export const projectCategoryApi = projectCategory(updatedAxios)
export const trainingApi = training(updatedAxios)
export const elearningCourseApi = elearningCourse(updatedAxios)
export const learningPathApi = learningPath(updatedAxios)
export const elearningAssignmentApi = elearningAssignment(updatedAxios)
export const elearningPathAssignmentApi = elearningPathAssignment(updatedAxios)
export const academyApi = academy(updatedAxios)
export const academyManagementApi = academyManagement(updatedAxios)
export const trainerApi = trainer(updatedAxios)
export const messageApi = message(updatedAxios)
export const usergroupApi = usergroup(updatedAxios)
export const searchApi = search(updatedAxios)
export const timesheetApi = timesheet(updatedAxios)
export const contractTypeApi = contractTypeHttpService(updatedAxios)
export const contractSuperTypeApi = contractSuperTypeHttpService(updatedAxios)
export const timesheetActivityApi = timesheetActivity(updatedAxios)
export const leaveApi = leave(updatedAxios)
export const holidayApi = holiday(updatedAxios)
export const projectStatusApi = projectStatus(updatedAxios)
export const publicHolidayApi = publicHoliday(updatedAxios)
export const timeZoneApi = timeZone(updatedAxios)
export const leaveTypeApi = leaveType(updatedAxios)
export const recruitmentApi = recruitment(updatedAxios)
export const candidateSpaceApi = candidateSpace(updatedAxios)
export const roomApi = room(updatedAxios)
export const invoicingInformationApi = invoicingInformation(updatedAxios)
export const commentApi = comment(updatedAxios)
export const companyContactApi = companyContact(updatedAxios)
export const activityApi = activity(updatedAxios)
export const salesWorkflowApi = salesWorkflow(updatedAxios)
export const salesFunnelViewApi = salesFunnelView(updatedAxios)
export const crmCustomFieldApi = crmCustomField(updatedAxios)
export const salesIcpConfigApi = salesIcpConfig(updatedAxios)
export const salesAiApi = salesAi(updatedAxios)
export const salesDueDiligenceApi = salesDueDiligence(updatedAxios)
export const assistantApi = assistant(updatedAxios)
export const proposalApi = proposal(updatedAxios)
export const evaluationApi = evaluation(updatedAxios)
export const evaluationAverageApi = evaluationAverage(updatedAxios)
export const trainingTrainerApi = trainingTrainer(updatedAxios)
export const trainingLocationApi = trainingLocation(updatedAxios)
export const trainingSessionApi = trainingSession(updatedAxios)
export const trainingPlanDraftApi = trainingPlanDraft(updatedAxios)
export const trainingCategoryApi = trainingCategory(updatedAxios)
export const trainingItemCategoryApi = trainingItemCategory(updatedAxios)
export const trainingItemApi = trainingItem(updatedAxios)
export const trainingCostCategoryApi = trainingCostCategory(updatedAxios)
export const trainingBudgetApi = trainingBudget(updatedAxios)
export const recruitmentRejectionCategoryApi = recruitmentRejectionCategory(updatedAxios)
export const recruitmentWithdrawalCategoryApi = recruitmentWithdrawalCategory(updatedAxios)
export const formularApi = formular(updatedAxios)
export const surveyApi = survey(updatedAxios)
export const profileApi = profileHttpService(updatedAxios)
export const managementApi = management(updatedAxios)
export const invoiceApi = invoice(updatedAxios)
export const evaluationSummaryApi = evaluationSummary(updatedAxios)
export const invoicingProjectsApi = invoicingProjects(updatedAxios)
export const invoicingTermApi = invoicingTerm(updatedAxios)
export const bankAccountApi = bankAccount(updatedAxios)
export const recruitmentWebsiteApi = RecruitmentWebsite(updatedAxios)
export const boardingProcessApi = boardingProcess(updatedAxios)
export const expenseApi = expense(updatedAxios)
export const jobOfferStatisticApi = jobOfferStatistic(updatedAxios)
export const userLogActionApi = userLogAction(updatedAxios)
export const howDidYouFindUsApi = howDidYouFindUs(updatedAxios)
export const employeeOnboardingApi = employeeOnboarding(updatedAxios)
export const meetingApi = meeting(updatedAxios)
export const countryApi = country(updatedAxios)
export const resourceChildrenApi = resourceChildren(updatedAxios)
export const jobBoardFormTemplateApi = jobBoardFormTemplate(updatedAxios)
export const expenseReportApi = expenseReport(updatedAxios)
export const jobStatusApi = jobStatus(updatedAxios)
export const departureCategoryApi = departureCategory(updatedAxios)
export const degreeFieldCategoryApi = degreeFieldCategory(updatedAxios)
export const customRecruitmentQuestionApi = customRecruitmentQuestion(updatedAxios)
export const signatureDocumentApi = signatureDocument(updatedAxios)
export const signatureTemplateApi = signatureTemplate(updatedAxios)
export const signatureCampaignApi = signatureCampaign(updatedAxios)
export const timesheetDailyDetailsApi = timesheetDailyDetails(updatedAxios)
export const objectiveApi = objective(updatedAxios)
export const projectCommissionCategoryApi = projectCommissionCategory(updatedAxios)
export const projectPricingCategoryApi = projectPricingCategory(updatedAxios)
export const employeeVariablesApi = employeeVariables(updatedAxios);
export const employeeWageApi = employeeWage(updatedAxios);
export const acknowledgmentCandidateReceiptTemplateApi = acknowledgmentCandidateReceiptTemplateHttpService(updatedAxios)
export const ticketApi = ticket(updatedAxios)
export const adminTicketApi = adminTicket(updatedAxios)
export const adminSearchApi = adminSearch(updatedAxios)
export const aiUsageApi = aiUsage(updatedAxios)
export const currencyApi = currency(updatedAxios)
export const recruitmentTagApi = recruitmentTag(updatedAxios)
export const jobCategoryApi = jobCategory(updatedAxios)
export const jobPathApi = jobPath(updatedAxios)
export const userSessionApi = userSession(updatedAxios)
export const adminUserSessionApi = adminUserSession(updatedAxios)
export const signatureStatsApi = signatureStats(updatedAxios)
export const apiUserApi = apiUser(updatedAxios)
export const integrationApi = integration(updatedAxios)
export const jobBoardApi = jobBoard(updatedAxios)
export const exportTemplateApi = exportTemplate(updatedAxios)
export const contentAssetApi = contentAsset(updatedAxios)
export const firmNewsApi = firmNews(updatedAxios)
export const meetingExchangeApi = meetingExchange(updatedAxios)
export const openReplayApi = openReplay(updatedAxios)
export const chatApi = chat(updatedAxios)
export const outlookApi = outlook(updatedAxios)
